const isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent);

export default isMobile;
